import React from 'react'

import { IconButtonWithTooltip } from '../buttons/Buttons'
import { translate } from '../../utils/translation'
import DownloadIcon from '../../styles/assets/download.svg'
import { LoadingWheel } from '../loading/Loading'
import { UnloggedModal } from '../exportPdf/unloggedModal'
import { ExportIcon } from '../exportPdf/exportIcon'

const tooltipDistanceInPixels = {
  MOBILE: 25,
  DESKTOP: 0,
}

export const ExportButton = ({
  shouldDisplayDownloadButton,
  onClick,
  disabled,
  isMobile,
  isLoading,
}) => {
  const distance = isMobile
    ? tooltipDistanceInPixels.MOBILE
    : tooltipDistanceInPixels.DESKTOP

  if (!shouldDisplayDownloadButton) {
    return (
      <UnloggedModal isImageExport>
        <ExportIcon size={20} distance={distance} />
      </UnloggedModal>
    )
  }

  if (isLoading) {
    return <LoadingWheel width={22} height={22} />
  }

  return (
    <IconButtonWithTooltip
      disabled={disabled}
      text={translate('export_chart')}
      icon={DownloadIcon}
      onClick={onClick}
      distance={distance}
    />
  )
}
